<template>
  <div>
    <Drawer v-model="showDrawer" width="80" title="学生转班">
      <div class="info-line">
        <span class="line-title">班级名称：</span>
        <strong class="line-content">{{ classroomName }}</strong>
      </div>
      <div class="info-line">
        <span class="line-title">上课日期：</span>
        <span class="line-content">{{ classDateStr }}</span>
      </div>
      <strong style="margin-bottom:6px" class="list-title red-dot">班级学生名单</strong>
      <div class="search-block">
        <Form
          ref="searchForm"
          :model="searchStudentData"
          label-position="right"
          :label-width="0"
        >
          <Row class="relative" type="flex" flex="end">
            <FormItem prop="classData" label="">
              <Cascader
                v-model="searchStudentData.classData"
                clearable
                :data="gradeAndClassList"
                placeholder="请选择年级班级"
                :change-on-select="true"
              ></Cascader>
            </FormItem>
            <FormItem prop="stuName" label="">
              <Input
                v-model="searchStudentData.stuName"
                clearable
                placeholder="请输入学生姓名"
                class="search-input-430"
              ></Input>
            </FormItem>
            <FormItem prop="status" label="">
              <Select v-model="searchStudentData.status" style="width:200px">
                <Option :key="1" :value="1">正常</Option>
                <Option :key="2" :value="2">节次已转入其他班级</Option>
              </Select>
            </FormItem>
            <Button type="primary" @click="handleSearchStudent">查询</Button>
            <Button class="search-430" @click="handleResetSearchStudent">重置</Button>
          </Row>
        </Form>
      </div>
      <div class="list-block">
        <Table
          ref="timeTable"
          border
          :columns="studentColumnsShow"
          :data="studentData"
          :max-height="300"
          :loading="loadingStudent"
          @on-row-click="toggleSelectStudent"
          @on-selection-change="getSelectStudent"
        >

          <template slot="gradeNameAndClassName" slot-scope="{ row }">
            <span>{{ row.gradeName }}{{ row.className }}</span>
          </template>
          <template slot="gradeNameAndClassName" slot-scope="{ row }">
            <span>{{ row.gradeName }}{{ row.className }}</span>
          </template>
          <template slot="classTimeBeginShow" slot-scope="{ row }">
            <span>{{ classTimeBeginShow }}</span>
          </template>
          <template slot="status">
            <span>{{ searchStudentDataTrue.status===1?'正常':'节次已转入其他班级' }}</span>
          </template>
          <template slot="action" slot-scope="{ row }">
            <span class="click-btn-430" @click="handleCancelChange(row)">撤销节次转班</span>
          </template>
        </Table>
        <Page
          :total="studentPageInfo.total"
          show-total
          :current="studentPageInfo.pageNum"
          :page-size-opts="pageSizeOpts"
          :page-size="studentPageInfo.pageSize"
          show-sizer
          class="page-right"
          @on-change="handleStudentPageChange"
          @on-page-size-change="handleStudentPageSizeChange"
        ></Page>
      </div>
      <div v-if="searchStudentDataTrue.status===1" class="step-two">
        <div class="info-line">
          <strong class="list-title red-dot">处理方式：</strong>
          <RadioGroup v-model="changeWay">
            <Radio :label="1">转入托管班</Radio>
            <Radio :label="2">请假回家</Radio>
          </RadioGroup>
        </div>
        <div class="info-line">
          <span class="line-title">已选：</span>
          <span>{{ signIdsAndStudentIdsAndClassIds.length }}人</span>
        </div>
        <div v-if="changeWay===1" class="search-block">
          <Form
            ref="searchForm"
            :model="searchClassData"
            label-position="right"
            :label-width="0"
          >
            <Row class="relative" type="flex" flex="end">
              <FormItem prop="classData" label="">
                <Cascader v-model="searchClassData.classData" :data="classTypeCascaderList" placeholder="请选择课程分类"></Cascader>
              </FormItem>
              <FormItem prop="classroomName" label="">
                <Input
                  v-model="searchClassData.classroomName"
                  clearable
                  placeholder="请输入入班的课程班级名称"
                  class="search-input-430"
                ></Input>
              </FormItem>
              <FormItem
                prop="beginTime"
              >

                <DatePicker
                  :value="searchClassData.beginTime"
                  type="date"
                  placeholder="选择时间"
                  class="w-121"
                  :options="options"
                  :clearable="false"
                  @on-change="handleGetDeadLine"
                ></DatePicker>
              </FormItem>
              <Button type="primary" @click="handleSearchClass">查询</Button>
              <Button class="search-430" @click="handleResetSearchClass">重置</Button>
            </Row>
          </Form>
        </div>
        <div v-if="changeWay===1" class="list-block">
          <Table
            ref="timeTable"
            border
            :columns="classColumns"
            :data="classData"
            :max-height="300"
            :loading="loadingClass"
            @on-row-click="getClassTableClick"
          >
            <template slot="radio" slot-scope="{ row }">
              <Radio :disabled="row.detailId===detailInfo.detailId" :value="daycareDetailId===row.detailId"></Radio>
            </template>
            <template slot="productAmt" slot-scope="{ row }">
              <span>{{ row.productAmt | showFee }}</span>
            </template>
            <template slot="classTimeBegin" slot-scope="{ row }">
              <span>{{ row.classTimeBegin | showDate }} {{ classTimeBeginShow }}（第{{ row.classNo }}节）</span>
            </template>
          </Table>
          <Page
            :total="classPageInfo.total"
            show-total
            :page-size-opts="pageSizeOpts"
            :current="classPageInfo.pageNum"
            show-sizer
            class="page-right"
            @on-change="handleClassPageChange"
            @on-page-size-change="handleClassPageSizeChange"
          ></Page>
        </div>
        <strong v-else>
          确认后，将发起请假单，并设置成请假可退款。
        </strong>
      </div>
      <div class="fixed-padding"></div>
      <div class="footer">
        <div class="btn-box">
          <Button class="search-430" @click="closeDrawer">取消</Button>
          <Button
            type="primary"
            class="search-430"
            @click="handleSure"
          >确定</Button>
        </div>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import common from '@/request/common/index.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import ChooseCourseType from '@c/searchBlock/ChooseCourseType.vue';
import { timeToYearStr, timeToStr, formatTime, moneyFenChangeYuan } from '@/utils/utils.js';
import { quelityTypeList, hostingTypeList } from '@/utils/dictionary';
export default {
  components: {
    ChooseCourseType
  },
  filters: {
    showFee(fee) {
      return moneyFenChangeYuan(fee);
    },
    showDate(date) {
      return timeToYearStr(date);
    }
  },
  props: {
    classroomId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      classTypeCascaderList: [
        {
          value: '1',
          label: '素质课程',
          children: [...quelityTypeList].slice(1, quelityTypeList.length)
        },
        {
          value: '2',
          label: '托管',
          children: [...hostingTypeList].slice(1, hostingTypeList.length)
        }
      ], // 课程分类列表
      showDrawer: false,
      searchStudentData: {
        stuName: null,
        classData: null,
        status: 1
      },
      searchStudentDataTrue: {},
      gradeAndClassList: [],

      studentColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '班级',
          slot: 'gradeNameAndClassName',
          minWidth: 120
        },
        {
          title: '课程商品名',
          key: 'prodName',
          minWidth: 120,
          tooltip: true
        },
        {
          title: '上课时间',
          slot: 'classTimeBeginShow',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '节次在班状态',
          slot: 'status',
          minWidth: 130
        }
      ],
      studentData: [],
      studentPageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      signIdsAndStudentIdsAndClassIds: [],
      classroomName: '',
      classDateStr: '',
      detailInfo: {},
      changeWay: 1, // 1： 转入托管班 2：请假回家
      classPageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchClassData: {
        classroomName: null,
        beginTime: null,
        classData: ['2', '24']
      },
      searchClassDataTrue: {

      },
      // 设置不可选时间
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      classColumns: [
        {
          title: ' ',
          slot: 'radio',
          width: 80,
          align: 'center'
        },
        {
          title: '课程班级名称',
          key: 'classroomName',
          minWidth: 120,
          align: 'center',
          tooltip: true
        },
        {
          title: '学期',
          key: 'termName',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '上课时间',
          slot: 'classTimeBegin',
          minWidth: 180
        },
        {
          title: '价格（元）',
          slot: 'productAmt',
          minWidth: 120
        },
        {
          title: '累计课时',
          key: 'classroomTotal',
          minWidth: 120
        }
      ],
      classData: [],
      daycareDetailId: '',
      loadingStudent: false,
      loadingClass: false,
      dealLoading: false

    };
  },
  computed: {
    ...mapState(['userInfo']),
    classTimeBeginShow() {
      if (this.showDrawer) {
        return `${timeToStr(this.detailInfo.classTimeBegin)}-${timeToStr(
          this.detailInfo.classTimeEnd
        )}`;
      } else {
        return '-';
      }
    },
    studentColumnsShow() {
      if (this.searchStudentDataTrue.status === 1) {
        return this.studentColumns;
      } else {
        return [...this.studentColumns, {
          title: '操作',
          slot: 'action',
          minWidth: 130
        }];
      }
    }
  },
  created() {
  },
  mounted() {
    this.getGradeAndClass();
  },
  methods: {
    // 打开侧边栏
    openDrawer(row) {
      this.showDrawer = true;
      this.detailInfo = row;
      const { classroomName, classDate, classNo } = row;
      this.classroomName = classroomName;
      this.classDateStr = `${timeToYearStr(classDate)}（第${classNo}节）`;
      this.handleResetSearchStudent();
      if (this.searchStudentDataTrue.status === 1) {
        this.handleResetSearchClass();
      }
    },
    closeDrawer() {
      this.showDrawer = false;
    },
    // 请求年级班级列表
    async getGradeAndClass() {
      if (this.schoolId == -1) return;
      const params = {
        schoolId: this.schoolId
      };
      console.log('年级班级接口');
      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },

    // 查询学生列表
    handleSearchStudent() {
      this.searchStudentDataTrue = {};
      Object.keys(this.searchStudentData).forEach(item => {
        if (this.searchStudentData[item]) {
          item === 'classData' ? (this.searchStudentDataTrue.gradeId = this.searchStudentData[item][0], this.searchStudentDataTrue.classId = this.searchStudentData[item][1]) : this.searchStudentDataTrue[item] = this.searchStudentData[item];
        }
      });
      this.studentPageInfo = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      };
      this.signIdsAndStudentIdsAndClassIds = [];
      if (this.searchStudentDataTrue.status === 1) {
        this.getStudentList();
      } else {
        this.getStudentDataHasChange();
      }
    },
    // 重置查询学生列表
    handleResetSearchStudent() {
      this.searchStudentData = {
        classData: null,
        stuName: '',
        status: 1
      };
      this.handleSearchStudent();
    },
    toggleSelectStudent(row, index) {
      row._checked = !row._checked;
      this.studentData.splice(index, 1, row);
      if (row._checked) {
        this.signIdsAndStudentIdsAndClassIds.push(row.signIdAndStudentIdAndClassId);
      }
    },
    // 获取选中的学生
    getSelectStudent(selection) {
      const signIdsAndStudentIdsAndClassIds = selection.map(item => item.signIdAndStudentIdAndClassId);
      const otherSignIds = [];
      const studentSignIds = this.studentData.map(item => item.signIdAndStudentIdAndClassId);
      this.signIdsAndStudentIdsAndClassIds.forEach(item => {
        if (studentSignIds.includes(item) === false) {
          otherSignIds.push(item);
        }
      });
      this.signIdsAndStudentIdsAndClassIds = [...signIdsAndStudentIdsAndClassIds, ...otherSignIds];
    },

    // 获取可以转班的学生信息
    async getStudentList() {
      const params = {
        detailId: this.detailInfo.detailId,
        pageSize: this.studentPageInfo.pageSize,
        pageNo: this.studentPageInfo.pageNum,
        ...this.searchStudentDataTrue
      };
      this.loadingStudent = true;
      try {
        const res = await courseSchedulCenter.findCanDaycarePageApi(params);
        if (res.status === 200) {
          this.studentData = res.message.list.map(item => {
            const signIdAndStudentIdAndClassId = `${item.signId}&${item.signPersonId}&${item.classId}`;
            const _checked = this.signIdsAndStudentIdsAndClassIds.includes(signIdAndStudentIdAndClassId);
            return {
              ...item,
              _checked,
              signIdAndStudentIdAndClassId
            };
          });
          this.studentPageInfo.total = +res.message.total;
        }
      } finally {
        this.loadingStudent = false;
      }
    },
    // 获取已转班的学生的
    async getStudentDataHasChange() {
      const params = {
        detailId: this.detailInfo.detailId,
        pageSize: this.studentPageInfo.pageSize,
        pageNo: this.studentPageInfo.pageNum,
        ...this.searchStudentDataTrue
      };
      this.loadingStudent = true;
      try {
        const res = await courseSchedulCenter.findDaycarePageApi(params);
        if (res.status === 200) {
          this.studentData = res.message.list.map(item => {
            return {
              studentName: item.stuName,
              ...item
            };
          });
          this.studentPageInfo.total = +res.message.total;
        }
      } finally {
        this.loadingStudent = false;
      }
    },
    handleStudentPageChange(pageNum) {
      this.studentPageInfo.pageNum = pageNum;
      this.getStudentList();
    },
    handleStudentPageSizeChange(size) {
      this.studentPageInfo.pageSize = size;
      this.studentPageInfo.pageNum === 1 && this.getStudentList();
    },
    handleGetDeadLine(time) {
      this.searchClassData.beginTime = time;
    },
    handleSearchClass() {
      this.searchClassDataTrue = {};
      Object.keys(this.searchClassData).forEach(item => {
        if (this.searchClassData[item]) {
          item === 'classData' ? (this.searchClassDataTrue['courseTypeKind'] = this.searchClassData[item][1]) : item === 'beginTime' ? (this.searchClassDataTrue['beginTime'] = `${this.searchClassData['beginTime']} 00:00:00`, this.searchClassDataTrue['endTime'] = `${this.searchClassData['beginTime']} 23:59:59`) : this.searchClassDataTrue[item] = this.searchClassData[item];
        }
      });
      this.classPageInfo = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      };
      this.daycareDetailId = '';
      this.getClassList();
    },
    handleResetSearchClass() {
      this.searchClassData = {
        classroomName: null,
        beginTime: null,
        classData: ['2', '24']
      };
      this.searchClassData.beginTime = formatTime(new Date(), 'yyyy-MM-dd');
      this.handleSearchClass();
    },
    // 获取可以转班的班级节次
    async getClassList() {
      const params = {
        originDetailId: this.detailInfo.detailId,
        pageSize: this.classPageInfo.pageSize,
        pageNo: this.classPageInfo.pageNum,
        ...this.searchClassDataTrue
      };
      this.loadingClass = true;
      try {
        const res = await courseSchedulCenter.findDaycareDetailPageApi(params);
        if (res.status === 200) {
          this.classData = res.message.list.map(item => {
            return {
              ...item
            };
          });
          this.classPageInfo.total = +res.message.total;
        }
      } finally {
        this.loadingClass = false;
      }
    },
    handleClassPageChange(pageNum) {
      this.classPageInfo.pageNum = pageNum;
      this.getClassList();
    },
    handleClassPageSizeChange(size) {
      this.classPageInfo.pageSize = size;
      this.classPageInfo.pageNum === 1 && this.getClassList();
    },
    getClassTableClick(row, index) {
      if (row.detailId === this.detailInfo.detailId) {
        return;
      }
      this.daycareDetailId = row.detailId;
    },
    handleSure() {
      if (this.searchStudentDataTrue.status === 2) {
        this.sureCancel();
        return;
      }
      if (this.changeWay === 1) {
        this.sureChangeClass();
        return;
      }
      if (this.changeWay === 2) {
        this.sureLeaveStudent();
      }
    },
    // 转班
    sureChangeClass() {
      if (this.signIdsAndStudentIdsAndClassIds.length === 0) {
        this.$Message.error('请选择要转班的学生');
        return;
      }
      if (this.daycareDetailId === '') {
        this.$Message.error('请选择要转入的班级');
        return;
      }
      this.changeClassTrue();
    },
    // 请假
    sureLeaveStudent() {
      if (this.signIdsAndStudentIdsAndClassIds.length === 0) {
        this.$Message.error('请选择要请假的学生');
        return;
      }
      this.changeToLeaveRefund();
    },
    sureCancel() {
      this.closeDrawer();
    },
    // 真正的请假
    // 改变成已请假（可退款）
    async changeToLeaveRefund() {
      this.$Spin.show();
      try {
        const list = this.signIdsAndStudentIdsAndClassIds.map(item => {
          const arr = item.split('&');

          return {
            signId: arr[0],
            studentId: arr[1],
            leaveDescribe: '',
            detailId: this.detailInfo.detailId,
            classroomId: this.classroomId,
            classId: arr[2],
            retMoneyEnum: 'CAN_REFUND' // 可退款
          };
        });
        // return;
        const res = await courseSchedulCenter.batchSaveLeaveApi(
          list
        );
        if (res.status === 200) {
          this.$Message.success('请假成功');
          this.closeDrawer();
        }
      } finally {
        this.$Spin.hide();
      }
    },
    // 真的转班
    async changeClassTrue() {
      const signIds = this.signIdsAndStudentIdsAndClassIds.map(item => {
        return item.split('&')[0];
      });
      const params = {
        detailId: this.detailInfo.detailId,
        daycareDetailId: this.daycareDetailId,
        signIds: signIds
      };
      this.$Spin.show();
      try {
        const res = await courseSchedulCenter.postDaycareApi(params);
        if (res.status === 200) {
          this.$Message.success('转班成功');
          this.closeDrawer();
        }
      } finally {
        this.$Spin.hide();
      }
    },
    // 撤销节次转班
    handleCancelChange(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '您确定撤销节次转班吗？',
        loading: true,
        onOk: () => {
          this.cancelChangeTrue(row);
        }
      });
    },
    async cancelChangeTrue(row) {
      const params = {
        detailId: this.detailInfo.detailId,
        daycareDetailId: row.daycareDetailId,
        signIds: [row.signId]
      };

      try {
        const res = await courseSchedulCenter.cancelDaycareApi(params);
        if (res.status === 200) {
          this.$Message.success('撤销节次转班成功');
          this.getStudentDataHasChange();
        }
      } finally {
        this.$Modal.remove();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info-line{
  margin-bottom: 10px;

}
.list-title{
  display: inline-block;
  &::before{
    content: '*';
    color: red;
  }
}
.search-block{
  /deep/.ivu-form-item{
    margin-right: 6px!important;
    margin-bottom: 6px!important;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.fixed-padding {
  width: 1px;
  height: 108px;
}
.footer {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 80%;
  padding: 10px 20px 20px;
  border-top: 1px solid #eee;
  background-color: #fff;
  .btn-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    button + button {
      margin-left: 16px;
    }
  }
}
</style>
